import React from "react";
import { Box, Stack } from "@mui/material";
import Section10A from "./Section10/Section10A";
import Section7 from "./Section7/Section7";
import Section11A from "./Section11/Section11A";
import Section11B from "./Section11/Section11B";
import Section9A from "./Section9/Section9A";
import Section8 from "./Section8/Section8";
import Section8Desktop from "./Section8/Section8Desktop";
// import OurTeam from "./ourTeam/OurTeam";
import OurTeam from "./ourTeam/OurTeam";
import OurTeamMobile from "./ourTeam/OurTeamMobile";
import EnquiryForm from "./EnquiryForm/EnquiryForm";
import MobileCardComponent from "./Section8/MobileCardComponent";
import Support from "./Support/Support";
import ScrollToTopButton from "./ScrollToTop";
import NavLinksSection from "./Section7/NavlinkSection";

const AboutUsPage = () => {
  return (
    <Stack>
      <Stack sx={{ height: "auto", display: "flex", flexDirection: "column" }}>
        {/* Section 7: Hero or Intro Section */}

        <Stack sx={{ height: "100%", width: "100%" }}>
          <Section7 />
        </Stack>

        <Stack
          sx={{
            height: "100%",
            width: "100%",
            position: "sticky",
            inset: 0,
            top: 0,
            zIndex: 2000,
          }}
        >
          <NavLinksSection />
        </Stack>

        {/* Section 10A */}
        <Stack sx={{ height: "100%", width: "100%" }}>
          <Section10A />
        </Stack>

        {/* Section 11A, 11Band 9A */}
        <Stack sx={{ height: "100%", width: "100%" }}>
          <Section11A />
          {/* <Section11B /> */}
          <Section9A />

          {/* Section8 for Desktop */}
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {/* <Section8Desktop /> */}
          </Box>

          {/* Our Team - Responsive */}
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <OurTeam />
          </Box>

          <Box sx={{ display: { xs: "block", sm: "none" } }}>
            <OurTeamMobile />
          </Box>
          {/* Enquiry Form */}

          <Box sx={{ height: "100%", width: "100%" }}>
            <EnquiryForm />
          </Box>

          <Box sx={{ height: "100%", width: "100%" }}>
            <Support />
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              backgroundColor: "#f8fafd",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: {
                  xl: "72%",
                  lg: "82%",
                  md: "95%",
                  sm: "100%",
                  xs: "100%",
                },
                flexDirection: {
                  lg: "row",
                  md: "column",
                  sm: "column",
                  xs: "column",
                },
                alignItems: {
                  lg: "start",
                  md: "center",
                  sm: "center",
                  xs: "center",
                },
                gap: "20px",
              }}
            >
              <Stack
                sx={{
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "100%",
                    lg: "100%",
                    xl: "100%",
                  },
                  // display: { xs: 'none', md: 'flex' }
                }}
              >
                <Support />
              </Stack>
            </Box>
          </Box> */}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AboutUsPage;
